import styled from 'styled-components';
import media from '../../../../styles/media.style';

export const Container = styled.div`
  padding-top: 80px;
  min-height: 100vh;
  padding-bottom: 24px;

  ${media.tabletP`
    padding-top: 120px;
    padding-bottom: 60px;
  `};
`;

export const DiagnosisContainer = styled.div`
  max-width: 738px;
  background: rgba(255, 255, 255, 0.6);
  margin: 30px 20px 0px 20px;
  padding: 40px 20px 50px 20px;
  box-shadow: 0px 2px 9px 1px rgba(0, 0, 0, 0.1);

  ${media.tabletP`
    margin: 0 auto;
    padding: 60px 76px 100px 76px;
  `};

  &.scalpCameraPage {
    width: calc(100% - 40px);
    display: flex;
    flex-direction: column;
    align-items: center;
    margin: 0 auto;
    padding: 60px 20px 100px 20px;
  }

  .skip_btn {
    text-align: center;
    margin-top: 40px;
    margin-bottom: -40px;
    .error_message {
      color: red;
    }
  }
`;

export const Title = styled.h1`
  font-size: 17px;
  text-align: center;
  color: #000;
  margin: 0 0 39px;

  ${media.tabletP`
    font-size: 30px;
    margin: 0.67em 0;
  `};

  &.scalpCameraPage {
    margin: 0 0 20px 0;
    font-size: 17px;

    ${media.tabletP`
      margin: 0 0 30px 0;
      font-size: 28px;
    `};
  }
`;

export const Description = styled.div`
  text-align: center;
  margin: 0 40px 40px;
  font-size: 12px;
  color: #000;

  ${media.tabletP`
    margin: 0 0 60px 0;
    font-size: 18px;
  `};

  &.scalpCameraPage {
    margin: 0 0 40px 0;

    ${media.tabletP`
      margin: 0 0 60px 0;
    `};
  }
`;

export const Button = styled.button`
  display: block;
  background: #8b9095;
  color: #fff;
  padding: 17px 60px;
  margin: 60px auto 0;
  font-size: 14px;
  width: 100%;
  border: none;

  &.stylistDiagnosis {
    margin: 20px auto 0;
  }
  ${media.tabletP`
    width: 300px;
    font-size: 16px;
    padding: 20px 60px;
    &.stylistDiagnosis {
      margin: 60px auto 20px;
    }
  `};

  &.scalpCameraPage {
    width: 100%;
    height: 48px;
    margin: 40px 20px 0 20px;
    padding: 0;
    font-size: 11px;

    ${media.tabletP`
      width: 300px;
      height: 60px;
      margin: 80px auto 0;
      font-size: 14px;
    `};
  }
`;

export const ContentsTitle = styled.h3`
  text-align: center;
  font-size: 16px;
  margin-top: 70px;
  margin-bottom: 30px;
  color: #000;
  ${media.tabletP`
    font-size: 22px;
  `};
`;

export const ContentsTitleSmall = styled.h4`
  text-align: center;
  color: #000;
  background: #eeeff1;
  font-size: 14px;
  padding: 8px 0;
  margin: 35px 0 26px 0;
  vertical-align: middle;
  ${media.tabletP`
    font-size: 16px;
    padding: 10px 0;
    margin: 40px 0;
  `};
`;

export const QuestionTitle = styled.h5`
  font-size: 14px;
  text-align: center;
  color: #000;
  margin-bottom: 14px;
  ${media.tabletP`
    font-size: 18px;
    margin-bottom: 20px;
  `};
`;



// WEBPACK FOOTER //
// ./src/pages/SalonConsultationPage/SublimicDiagnosisPage/Common/Common.style.js